import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncPromoPage = async(() =>
  import('../containers/promoPage/PromoPage').then(module => module.default)
);

const PromoRouteHandler = ({
  match: {
    params: {
      promoUrl = 'default'
    }
  }
}) => (<AsyncPromoPage promoUrl={promoUrl} />);

export default function () {
  return (
    <Route
      path="/promo/:promoUrl?"
      component={PromoRouteHandler}
    />
  );
}

PromoRouteHandler.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      promoUrl: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
